import type Store from "@ember-data/store";
import Route from "@ember/routing/route";
import { service } from "@ember/service";
import BloodPressureSessionModelView from "parog-web/models/blood-pressure-session-model-view";
import type Patient from "parog-web/models/patient";
import type FetcherService from "parog-web/services/fetcher";
import type NavigationService from "parog-web/services/navigation";

export default class BloodPressureSessionsNewRoute extends Route {
  @service declare store: Store;
  @service declare fetcher: FetcherService;
  @service declare navigation: NavigationService;

  declare currentModel: BloodPressureSessionModelView;

  model(): BloodPressureSessionModelView {
    const patient = this.modelFor(
      `${this.navigation.currentPatientRouteName}`
    ) as Patient;

    // It is the job of the back to create the sessions.
    // So this session will be removed when living the route
    const session = this.store.createRecord(
      "blood-pressure-session-started-journal-event",
      {
        occurredAt: new Date()
      }
    );

    return new BloodPressureSessionModelView(
      this.store,
      this.fetcher,
      session,
      patient
    );
  }
}
